import Grid from '@mui/material/Grid';
import CVDCardGenetics from '../../../../../../components/Cards/CVDCardGenetics';
//import CardElements from "../../../../../components/TextComps/CardElements";


export default function Atherogenesis() {

return (
<>
<CVDCardGenetics 

cardheadline = 'ATHEROGENESIS'
content = {<>

                <Grid container> 

                        
                </Grid>
    </>}   
    
/>    
</>
)};
